import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bestcabserviceinpune() {



const cardData =
{
  keyword: 'Best Cab Service in Pune',
  heading: 'Lotus Cab: Best Cab Service in Pune',
  headingDescription: 'Lotus Cab proudly offers the Best Cab Service in Pune, delivering safe, reliable, and affordable transportation solutions across the city and beyond. Whether you need a quick local taxi, airport pickup, corporate travel, wedding transportation, or long-distance outstation cab service, our professionally managed fleet ensures comfort and punctuality. We operate well-maintained AC sedan and SUV vehicles driven by experienced, background-verified chauffeurs who understand Pune’s traffic patterns, major IT hubs, railway stations, and highway routes. Our transparent pricing structure eliminates hidden charges, providing customers with complete fare clarity before booking. With 24-hour cab availability, instant online booking confirmation, and dedicated customer support, Lotus Cab ensures stress-free travel for individuals, families, and corporate clients. From daily commuting to luxury executive rides, we deliver excellence in every journey.',

  top: 'Top Places to Visit in Pune with Lotus Cab',

  "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Shaniwar Wada is Pune’s most iconic historical monument, representing the glory of the Maratha Empire. Built in 1732, this grand fort once served as the seat of the Peshwas. Visitors explore its massive gates, fortified walls, and historical ruins that narrate tales of bravery and royal heritage. The evening light-and-sound show enhances the experience with dramatic storytelling. Lotus Cab provides comfortable city cab services to Shaniwar Wada with easy pickup and drop."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Aga Khan Palace is a symbol of India’s freedom struggle and architectural elegance. It served as a prison for Mahatma Gandhi during the Quit India Movement. The palace gardens and museum reflect historical significance and peaceful surroundings. Many tourists visit to understand Pune’s contribution to national history. Lotus Cab ensures reliable transportation to this landmark."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Sinhagad Fort is a historic hilltop fortress known for its association with Tanaji Malusare and Chhatrapati Shivaji Maharaj. The fort offers breathtaking panoramic views and adventurous trekking routes. Families and history lovers frequently visit for weekend outings. Lotus Cab provides safe and convenient travel to the base of Sinhagad."
    },
    {
      "title": "Dagdusheth Halwai Ganpati Temple",
      "description": "This famous temple is one of Pune’s most revered spiritual centers. The beautifully decorated idol of Lord Ganesha attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes a vibrant celebration hub. Lotus Cab provides timely local taxi services for darshan visits."
    },
    {
      "title": "Parvati Hill",
      "description": "Parvati Hill offers a spiritual experience and panoramic city views. The temple complex and 108-step climb make it a popular tourist attraction. It is ideal for sunrise and sunset visits. Lotus Cab ensures smooth transportation to this peaceful hilltop."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses thousands of rare artifacts, reflecting India’s artistic and cultural heritage. It is a must-visit for art and history enthusiasts. Lotus Cab provides reliable city cab booking for museum visits."
    },
    {
      "title": "Khadakwasla Dam",
      "description": "Khadakwasla Dam is a scenic picnic spot near Pune, especially popular during monsoon. Families enjoy sunset views and local food stalls. Lotus Cab offers comfortable family trip cab services to this location."
    },
    {
      "title": "Osho International Meditation Resort",
      "description": "Located in Koregaon Park, Osho Resort attracts global visitors seeking meditation and wellness. Lotus Cab offers reliable taxi services for visitors staying in Pune."
    },
    {
      "title": "Phoenix Marketcity",
      "description": "Phoenix Marketcity is a popular shopping and entertainment hub. Families book cabs for comfortable shopping trips. Lotus Cab provides convenient city pickup and drop taxi services."
    },
    {
      "title": "Pune Airport",
      "description": "Pune International Airport connects the city to major domestic and international destinations. Timely airport transfers are essential. Lotus Cab offers reliable airport cab services with punctual pickup."
    }
  ],

  "services": [
    {
      "name": "Best Cab Service in Pune",
      "description": "Lotus Cab is recognized as the Best Cab Service in Pune, offering reliable, punctual, and professional taxi services for local, airport, and outstation travel. Our fleet includes clean AC sedans and SUVs driven by experienced chauffeurs. Transparent pricing and 24-hour support ensure a stress-free ride every time."
    },
    {
      "name": "Top Taxi Service Pune",
      "description": "Our Top Taxi Service Pune delivers comfort and reliability across city routes and highway travel. Customers enjoy on-time pickup, professional drivers, and competitive fares."
    },
    {
      "name": "Reliable Cab Service Pune",
      "description": "Lotus Cab provides dependable and Reliable Cab Service Pune with consistent service standards and safe driving practices."
    },
    {
      "name": "Affordable Cab Service Pune",
      "description": "Affordable Cab Service Pune with transparent pricing, no hidden charges, and budget-friendly ride options."
    },
    {
      "name": "Pune Airport Cab Service",
      "description": "Timely Pune Airport Cab Service with flight tracking and luggage assistance."
    },
    {
      "name": "Pune Outstation Cab Service",
      "description": "Comfortable Pune Outstation Cab Service for long-distance travel with flexible one-way and round-trip options."
    },
    {
      "name": "24 Hours Cab Service Pune",
      "description": "Round-the-clock 24 Hours Cab Service Pune ensuring availability anytime you need a ride."
    },
    {
      "name": "Corporate Cab Service Pune",
      "description": "Professional Corporate Cab Service Pune for business meetings and executive travel."
    },
    {
      "name": "Local Taxi Service Pune",
      "description": "Convenient Local Taxi Service Pune for shopping, office, and daily commuting."
    },
    {
      "name": "Luxury Cab Service Pune",
      "description": "Premium Luxury Cab Service Pune for weddings, VIP travel, and executive rides."
    }
  ],

  "tableData": [
    ["Best Cab Service in Pune", "Top Taxi Service Pune"],
    ["Reliable Cab Service Pune", "Affordable Cab Service Pune"],
    ["Pune Airport Cab Service", "Pune Outstation Cab Service"],
    ["24 Hours Cab Service Pune", "Corporate Cab Service Pune"],
    ["Local Taxi Service Pune", "Pune City Cab Booking"],
    ["Luxury Cab Service Pune", "AC Cab Service Pune"],
    ["Online Cab Booking Pune", "Trusted Taxi Service Pune"],
    ["Budget Cab Service Pune", "Pune Family Trip Cab Service"],
    ["Wedding Cab Service Pune", "Pune Pickup and Drop Taxi"],
    ["Cheap Cab Service Pune", ""]
  ],

  "whychoose": [
    { "WhyChooseheading": "Trusted Service Provider", "WhyChoosedescription": "Lotus Cab is trusted by thousands of Pune customers for safe and reliable taxi services." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "We maintain clear pricing policies without hidden charges." },
    { "WhyChooseheading": "Professional Drivers", "WhyChoosedescription": "Experienced, background-verified drivers ensure safety." },
    { "WhyChooseheading": "24/7 Availability", "WhyChoosedescription": "Our cab services operate round the clock." },
    { "WhyChooseheading": "Clean & Maintained Fleet", "WhyChoosedescription": "All vehicles are regularly serviced and sanitized." },
    { "WhyChooseheading": "Airport Transfer Expertise", "WhyChoosedescription": "On-time airport pickup and drop service." },
    { "WhyChooseheading": "Corporate Travel Solutions", "WhyChoosedescription": "Dedicated corporate cab packages." },
    { "WhyChooseheading": "Family-Friendly Service", "WhyChoosedescription": "Spacious vehicles for safe family travel." }
  ]
}

const faqData = [
  { question: 'Does Lotus Cab provide the best cab service in Pune?', answer: 'Yes, Lotus Cab offers reliable and affordable taxi services across Pune.' },
  { question: 'Is airport pickup available?', answer: 'Yes, we provide timely airport transfer services.' },
  { question: 'Are fares transparent?', answer: 'Yes, we follow a clear pricing policy.' },
  { question: 'Is service available 24/7?', answer: 'Yes, we operate round the clock.' },
  { question: 'Do you provide corporate cab services?', answer: 'Yes, we cater to business travel needs.' },
  { question: 'Are vehicles sanitized?', answer: 'Yes, vehicles are cleaned before every trip.' },
  { question: 'Can I book online?', answer: 'Yes, online booking is available.' },
  { question: 'Do you offer luxury cabs?', answer: 'Yes, luxury vehicles are available.' },
  { question: 'Are one-way trips available?', answer: 'Yes, one-way and round-trip options are offered.' },
  { question: 'Is advance booking recommended?', answer: 'Yes, advance booking ensures availability.' }
];

const testimonials = [
  { id: 1, name: 'Mr. Sandeep Kulkarni', feedback: 'Excellent cab service in Pune with professional driver and clean car.', rating: 5 },
  { id: 2, name: 'Mrs. Priya Shah', feedback: 'Reliable airport cab service with transparent pricing. Highly recommended.', rating: 5 }
];








































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Cab Service in Pune",
  "image": "https://lotuscab.com/assets/images/best-cab-service-in-pune.jpg", 
  "description": "Lotus Cab provides the best cab service in Pune with reliable, affordable and 24 hours taxi service for airport, local, outstation, corporate and family trips. Book AC, sedan, SUV and luxury cabs with professional drivers at competitive rates.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "6800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/best-cab-service-in-pune"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Best Cab Service in Pune | Lotus Cab</title>
  <meta 
    name="description" 
    content="Looking for the best cab service in Pune? Lotus Cab offers reliable, affordable 24 hours taxi service for airport, local & outstation travel. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Best Cab Service in Pune, Top Taxi Service Pune, Reliable Cab Service Pune, Affordable Cab Service Pune, Pune Airport Cab Service, Pune Outstation Cab Service, 24 Hours Cab Service Pune, Corporate Cab Service Pune, Local Taxi Service Pune, Pune City Cab Booking, Luxury Cab Service Pune, AC Cab Service Pune, Online Cab Booking Pune, Trusted Taxi Service Pune, Budget Cab Service Pune, Pune Family Trip Cab Service, Wedding Cab Service Pune, Pune Pickup and Drop Taxi, Cheap Cab Service Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bestcabserviceinpune;